import store from "@/store";

function check(el, binding) {
  const perm = binding.value;
  if (!perm) return;
  if (!store.getters["admin/hasPermission"](perm)) {
    if (binding.modifiers.disable) {
      el.disabled = true;
      el.style.opacity = "0.5";
      el.style.cursor = "not-allowed";
      el.style.pointerEvents = "auto";
    } else {
      el.style.display = "none";
    }
  }
}

export default {
  mounted(el, binding) {
    check(el, binding);
  },
  updated(el, binding) {
    check(el, binding);
  },
};
